import axios from 'axios';
import { queryCache, useMutation } from 'react-query';

const deleteAssignment = ({ courseId, setId }) => {
  return axios.delete(`/api/v3/courses/${courseId}/sets/${setId}`);
};

const useDeleteAssignment = () => {
  return useMutation(deleteAssignment, {
    onSuccess: (_, variables) => {
      const { courseId } = variables;
      // Invalidate all assignment-related queries to ensure table updates
      queryCache.invalidateQueries('assignments');
      queryCache.invalidateQueries(['assignments', courseId]);
      queryCache.invalidateQueries(['paginatedAssignments', courseId]);
    },
    onError: (error: any) => {
      console.error(`ERROR! ${error}`);
    }
  });
};

export default useDeleteAssignment;
